import { Component, Input, Output, EventEmitter, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";
import { RegistrationService } from "../../services/registration.service";
import { Subscription } from "rxjs";
import { BusyIconService } from "../../services/busy.service";
import { EUserType } from "../../models/userInfo.model";
import { User } from "../../models/user.model";

@Component({
  selector: "registration-wizard",
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
    }
  `],
  templateUrl: "registration-wizard.template.html"
})
export class RegistrationWizardComponent {
  @Input() step = 1;
  @Input() registrationForm: FormGroup;
  @Input() registrationToken: string;
  @Input() selectedMode: EUserType;
  @Output() finish = new EventEmitter();
  @Output() stepChange = new EventEmitter();

  private steps = 0;

  constructor(public router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              public translation: L10nTranslationService,
              private registrationService: RegistrationService,
              private busyIconService: BusyIconService) {
  }

  public addStep() {
    const newSteps = this.steps + 1;
    this.steps = newSteps;

    return newSteps;
  }

  generateToken(valid: boolean) {
    if (valid && this.selectedMode) {
        const email = this.registrationForm.controls["equal_email"].value["email"].toLowerCase();
        const registrationSubscription: Subscription = this.registrationService.generateRegistrationToken(email).subscribe((response) => {
            if (response) {
              this.registrationToken="";
              this.stepChange.emit(5);
            }
          },
          (err) => {
            console.log(err);
          });
        this.busyIconService.showBusyIcon(registrationSubscription);
      }
    }

  confirmTokenAndRegister({value, valid}: { value: User, valid: boolean }) {
    const token = this.registrationToken !== "" ? this.registrationToken : null;
    if (valid && this.selectedMode && token) {
      value.accountType = this.selectedMode === EUserType.SUPPLIER ? EUserType.CARRIER : this.selectedMode;
      value.phone = this.registrationForm.controls["one_of_two"].value["phone"];
      value.mobile = this.registrationForm.controls["one_of_two"].value["mobile"];
      value.password = this.registrationForm.controls["equal_password"].value["password"];
      value.email = this.registrationForm.controls["equal_email"].value["email"].toLowerCase();
      const registrationSubscription: Subscription = this.registrationService.confirmTokenAndRegister(value, token).subscribe((response) => {
          if (response) {
            this.stepChange.emit(7);
          } else {
            this.stepChange.emit(6);
          }
        },
        (err) => {
          console.log(err);
        });
      this.busyIconService.showBusyIcon(registrationSubscription);
    }
    else {
      this.stepChange.emit(6);
    }
  }

  public isOnConfirmTokenStep = () => this.step === 5;
  public isOnRequestTokenStep = () => this.step === 4;
  public isOnSuccessfulRegistrationStep = () => this.step === 7;
  public isOnFailedRegistrationStep = () => this.step === 6;
  public isOnFirstStep = () => this.step === 1;

  registrationTokenValid(): boolean {
    return this.registrationToken.length === 6;
  }
}
